import React from 'react';

import GetPostsByType from '@src/api/GetPostsByType';
import { generatePost } from '@src/factories';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { Post } from '@src/types';

const useFriendsPosts = () => {
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<Post[]> => {
      const response = await GetPostsByType(
        accessToken,
        'FOLLOWING',
        'DATE',
        offset,
        limit,
        axiosRequestConfig
      );
      return response.data.checkIns.map((business) => generatePost(business));
    },
    [accessToken, axiosRequestConfig]
  );

  const flat = useFlatList(makeRequest);

  return React.useMemo(() => ({ ...flat }), [flat]);
};

export default useFriendsPosts;
